import { EV_TOPIC_TM, EventType } from './../model/events.model';
import { Injectable } from '@angular/core';
import { CacheId, ICache, MemoryCache } from '../model/cache.model';
import { EventsService } from './events.service';

@Injectable({
    providedIn: 'root'
})
export class CacheService {

    private _caches = new Map<CacheId, ICache<any, any>>();

    constructor(srvEvents: EventsService) {
        srvEvents.subscribe(EV_TOPIC_TM, ev => {
            if (ev.type == EventType.TM_TIME_CHANGE)
                this.clearAllCaches();
        })
    }

    createMemoryCache<K, T>(cacheId: CacheId, maxItems?: number, ttlMinutes?: number): ICache<K, T> {
        let c = new MemoryCache<K, T>(maxItems, ttlMinutes);
        this._caches.set(cacheId, c);
        return c;
    }

    clearCache(cacheId: CacheId) {
        let c = this._caches.get(cacheId);
        if (c)
            c.clear();
    }

    clearCacheEntry(cacheId: CacheId, entryId: any) {
        let c = this._caches.get(cacheId);
        if (c)
            c.deleteItem(entryId);
    }

    clearCacheEntries(cacheId: CacheId, entryIds: any[]) {
        let c = this._caches.get(cacheId);
        if (c)
            entryIds.forEach(id => c.deleteItem(id));
    }

    clearAllCaches() {
        this._caches.forEach(cache => cache.clear());
    }

}

